import { render, staticRenderFns } from "./dev.vue?vue&type=template&id=796ee502&scoped=true&"
import script from "./dev.vue?vue&type=script&lang=js&"
export * from "./dev.vue?vue&type=script&lang=js&"
import style0 from "./dev.vue?vue&type=style&index=0&id=796ee502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ee502",
  null
  
)

export default component.exports